import { pointsToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';
import { Coordinate } from 'ol/coordinate';
import { LineString } from 'ol/geom';
import * as olStyle from 'ol/style';

/**
 * @author NikolaV
 */
const FEATURE_TYPE = 'alignment';

export const colorToRGB = (colorStr: string | undefined): string | number[] | undefined => {
    if (!colorStr) return 'red';

    if (colorStr.includes(',')) {
        const rgb = colorStr.split(',').map((c) => parseInt(c.trim()));
        if (rgb.length === 3 && rgb.every((c) => !isNaN(c) && c >= 0 && c <= 255)) {
            return [rgb[0], rgb[1], rgb[2]];
        }
    }

    return colorStr;
};

const styles = {
    normal: (color: string | number[] = 'red') =>
        new olStyle.Style({
            stroke: new olStyle.Stroke({
                color: color,
                width: 1,
            }),
        }),
    selected: (color: string | number[] = 'red') =>
        new olStyle.Style({
            stroke: new olStyle.Stroke({
                color: color,
                width: 3,
            }),
        }),
    hitArea: new olStyle.Style({
        stroke: new olStyle.Stroke({
            color: [0, 0, 0, 0.005],
            width: 15,
        }),
    }),
};

function styleFunction(feature: FeatureLike) {
    const data = feature.get('data');
    const color = colorToRGB(data?.color) || 'red';

    return [styles.hitArea, styles.normal(color)];
}

function makeFeature(alignment: IAlignment, mouseInteraction?: FeatureMouseInteraction): Feature {
    const coords: Coordinate[] = pointsToEN(alignment.points);
    if (!coords) {
        console.warn('Skipping bad alignment: ', alignment);
        throw new Error();
    }

    const feature = new Feature({
        geometry: new LineString(coords),
    });

    const source: FeatureSource = {
        modelId: alignment.modelId,
    };

    feature.setId((alignment.modelId || 'unknown') + '_' + (alignment.index || 0));
    feature.set('source', source);
    feature.set('index', alignment.index);
    feature.set('data', alignment);
    feature.set('type', FEATURE_TYPE);
    feature.set('mouseInteraction', mouseInteraction);

    return feature;
}

export const AlignmentFeatureFactory = {
    makeFeature,
    styleFunction,
    styles,
    FEATURE_TYPE,
};
